import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { AuthService } from '@core/services/auth.service';
import { environment } from '@env/*';
import { catchError, mergeMap } from 'rxjs/operators';

@Injectable()
export class ParamInterceptor implements HttpInterceptor {
  tokenRefreshing = false;

  constructor(private authService: AuthService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headerParams: any = {
      setHeaders: {
        'client-ver': environment.clientVersion,
        'api-ver': environment.apiVersion,
        // lang: localStorage.getItem('lang'),
      },
    };

    if (this.authService.isAuthenticated()) {
      headerParams.withCredentials = true;
      headerParams.setHeaders = Object.assign(headerParams.setHeaders, {
        Authorization: this.authService.getTokenFromStorage(environment.authToken),
      });
    }
    const updatedRequest = request.clone(headerParams);

    return next.handle(updatedRequest).pipe(
      catchError((error) => {
        if (error.status === 401 && this.authService.isAuthenticated() && !this.tokenRefreshing) {
          this.tokenRefreshing = true;
          return this.authService.refreshToken().pipe(
            mergeMap((res) => {
              const headers = updatedRequest.headers.set('Authorization', res.session_token);
              this.tokenRefreshing = false;
              const cloneReq = updatedRequest.clone({ headers });
              location.reload();
              return next.handle(cloneReq);
            }),
            catchError((e) => {
              this.authService.logout();
              return throwError(e);
            })
          );
        }
        return throwError(error);
      })
    );
  }
}
